import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import store from './redux/store';

// Helper to map market code to i18n language code
const marketToLang = (market) => (market === 'fr' ? 'fr-FR' : 'en-US');

// Determine initial language from Redux state
const initialMarket = store.getState()?.route?.market;
const initialLng = marketToLang(initialMarket);

// Initialize i18next
// We use HTTP backend to load translation files from public/locale/{{lng}}/translation.json
// CRA serves files under public at the root path.
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: 'en-US',
    supportedLngs: ['en-US', 'fr-FR'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locale/{{lng}}/translation.json',
    },
    react: {
      useSuspense: false,
    },
  });

// Subscribe to Redux store to react to market changes at runtime
let currentMarket = initialMarket;
store.subscribe(() => {
  const nextMarket = store.getState()?.route?.market;
  if (nextMarket !== currentMarket) {
    currentMarket = nextMarket;
    const nextLng = marketToLang(nextMarket);
    if (i18n.language !== nextLng) {
      i18n.changeLanguage(nextLng);
    }
  }
});

export default i18n;
